/* Packages */
import React from "react";
import RadioList from "@webstores/webstores-configurator/dist/inputs/RadioList";
import TextArea from "@webstores/webstores-configurator/dist/inputs/TextArea";

/* Components */
import TextField from "../inputs/CustomTextField";
import ImageUpload from "../inputs/CustomImageUpload";
import { Button } from '../../../common';

export default function ConversionProductTradeProposalVehicle({
    stepData,
    setStepData,
    title,
    isLoading
}) {
    /* Constants */
    const { data, inputs } = stepData;
    const damageFree = (inputs['damage-free']?.choices.find(choice => choice.active)?.id === '0');

    /* Render */
    return (
        <>
            <h3 className="h2 mb-6 mb-lg-10">{title}</h3>
            <div className="row gutters-3">
                <div className="col-12 col-lg-10 col-xl-9">
                    <div className="row gutters-3 gutters-xl-6 mb-6 mb-lg-10">
                        <div className="col-12 col-lg-6 col-xxl-5">
                            <label htmlFor="trade-proposal-license-plate">
                                {inputs['license-plate'].label} {inputs['license-plate'].required && "*"}
                            </label>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text input-group--license-plate">NL</span>
                                </div>
                                <TextField
                                    id="trade-proposal-license-plate"
                                    className="form-control form-control--license-plate"
                                    input={inputs['license-plate']}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    field={"inputs.license-plate"}
                                    preventUpdate={false}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-xxl-7">
                            <label htmlFor="trade-proposal-mileage">
                                {inputs.mileage.label} {inputs.mileage.required && "*"}
                            </label>
                            <div className="input-group">
                                <TextField
                                    id="trade-proposal-mileage"
                                    className="form-control"
                                    input={inputs.mileage}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    field={"inputs.mileage"}
                                    preventUpdate={false}
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text input-group--mileage">
                                        <div className="d-flex align-items-center bg-white px-4 h-100">km</div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {data?.additionalData?.tradeInVehicle?.brand && (
                            <div className="col-12">
                                <div className="card card--trade-vehicle">
                                    <div className="card-body p-5 p-lg-7">
                                        <p className="mb-0">Dit is uw auto</p>
                                        <p className="card-title">{data.additionalData.tradeInVehicle.brand} {data.additionalData.tradeInVehicle.model}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="col-12">
                            <p className="h6">Conditie van uw auto</p>
                        </div>
                        <div className="col-12">
                            <div className="row gutters-3 gutters-lg-4">
                                <div className="col-12">
                                    <div className="row gutters-2 pb-5 border-bottom border--base-10 border-width-sm">
                                        <div className="col-12 col-lg-5">
                                            <label className="d-block" htmlFor="trade-proposal-condition-exterior">
                                                {inputs['condition-exterior'].label}
                                            </label>
                                        </div>
                                        <div className="col-12 col-lg-7">
                                            <div className="row gutters-1 ml-7">
                                                <RadioList
                                                    id="trade-proposal-condition-exterior"
                                                    className="col-4 custom-control custom-radio mb-0"
                                                    inputClassName="custom-control-input"
                                                    labelClassName="custom-control-label"
                                                    input={inputs['condition-exterior']}
                                                    stepData={stepData}
                                                    setStepData={setStepData}
                                                    preventUpdate={false}
                                                    field={"inputs.condition-exterior"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row gutters-2 pb-5 border-bottom border--base-10 border-width-sm">
                                        <div className="col-12 col-lg-5">
                                            <label className="d-block" htmlFor="trade-proposal-condition-interior">
                                                {inputs['condition-interior'].label}
                                            </label>
                                        </div>
                                        <div className="col-12 col-lg-7">
                                            <div className="row gutters-1 ml-7">
                                                <RadioList
                                                    id="trade-proposal-condition-interior"
                                                    className="col-4 custom-control custom-radio mb-0"
                                                    inputClassName="custom-control-input"
                                                    labelClassName="custom-control-label"
                                                    input={inputs['condition-interior']}
                                                    stepData={stepData}
                                                    setStepData={setStepData}
                                                    preventUpdate={false}
                                                    field={"inputs.condition-interior"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row gutters-2 pb-3 pb-lg-5 border-bottom border--base-10 border-width-sm">
                                        <div className="col-12 col-lg-5">
                                            <label className="d-block" htmlFor="trade-proposal-condition-of-tyres">
                                                {inputs['condition-of-tyres'].label}
                                            </label>
                                        </div>
                                        <div className="col-12 col-lg-7">
                                            <div className="row gutters-1 ml-7">
                                                <RadioList
                                                    id="trade-proposal-condition-of-tyres"
                                                    className="col-4 custom-control custom-radio mb-0"
                                                    inputClassName="custom-control-input"
                                                    labelClassName="custom-control-label"
                                                    input={inputs['condition-of-tyres']}
                                                    stepData={stepData}
                                                    setStepData={setStepData}
                                                    preventUpdate={false}
                                                    field={"inputs.condition-of-tyres"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row gutters-2">
                                        <div className="col-12 col-lg-5">
                                            <label className="d-block" htmlFor="trade-proposal-damage-free">
                                                {inputs['damage-free'].label}
                                            </label>
                                        </div>
                                        <div className="col-12 col-lg-7">
                                            <div className="row gutters-1 ml-7">
                                                <RadioList
                                                    id="trade-proposal-damage-free"
                                                    className="col-4 custom-control custom-radio mb-0"
                                                    inputClassName="custom-control-input"
                                                    labelClassName="custom-control-label"
                                                    input={inputs['damage-free']}
                                                    stepData={stepData}
                                                    setStepData={setStepData}
                                                    preventUpdate={false}
                                                    field={"inputs.damage-free"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {!damageFree && (
                            <div className="col-12">
                                <label htmlFor={`trade-proposal-damage-free-remarks`}>
                                    {inputs['damage-free-remarks'].label} {inputs['damage-free-remarks'].required && "*"}
                                </label>
                                <TextArea
                                    id={`trade-proposal-damage-free-remarks`}
                                    className="form-control"
                                    input={inputs['damage-free-remarks']}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    field={`inputs.damage-free-remarks`}
                                />
                            </div>
                        )}
                        <div className="col-12">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <p className="h6 mb-0">Foto’s toevoegen</p>
                                <p className="text-muted--40">Optioneel</p>
                            </div>
                            <p>Voeg foto’s toe van uw auto. Dit is optioneel maar zorgt uiteindelijk wel voor een betere prijsindicatie.</p>
                        </div>
                        <div className="col-12">
                            <div className="row gutters-1">
                                {Object.entries(inputs).filter(([key, input]) => input.type === 'image').map(([key, input]) => (
                                    <div key={key} className="col-12 col-lg-3">
                                        <ImageUpload
                                            id={`trade-proposal-${key}`}
                                            className=""
                                            input={input}
                                            stepData={stepData}
                                            setStepData={setStepData}
                                            field={`inputs.${key}`}
                                            preventUpdate={true}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="row gutters-3 gutters-xl-6 mb-4 mb-lg-10">
                        <div className="col-12 col-lg-6 col-xxl-5">
                            <Button
                                classes="btn-block"
                                linkTitle="Volgende stap"
                                isLoading={isLoading}
                                type="submit"
                            />
                        </div>
                        <div className="col-12 col-lg-6 col-xxl-7">
                            <div className="d-flex align-items-center h-100">
                                <p className="text-muted--60">Nog maar 1 stap te gaan hierna!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
